import * as React from 'react';
import { Grid, Box, Typography, MenuItem, Select, FormControl, InputLabel } from "@mui/material";
import PaymentsTable from 'components/Tables/PaymentsTable';
import DummyTable from 'components/DummyViews/DummyTable';
import ProgressScale from 'components/ProgressScale';
import BasicSelect from 'components/select';
import FormDialog from 'components/modal';
import { useGetPaymentsData, useRentals } from 'services/hooks/rentals';
import moment from "moment";

export default function Payments() {
    const [rental, setRental] = React.useState('')
    const [open, setOpen] = React.useState(false);
    const [year, setYear] = React.useState(new Date().getFullYear());
    const [month, setMonth] = React.useState(moment().format("MM")); // Use "MM" format for numbers

    // Add these arrays:
    const years = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - 2 + i);
    const months = [
        { value: "January", label: "January" },
        { value: "February", label: "February" },
        { value: "March", label: "March" },
        { value: "April", label: "April" },
        { value: "May", label: "May" },
        { value: "June", label: "June" },
        { value: "July", label: "July" },
        { value: "August", label: "August" },
        { value: "September", label: "September" },
        { value: "October", label: "October" },
        { value: "November", label: "November" },
        { value: "December", label: "December" },
    ];

    // Update hooks to accept year and month
    const { paymentsData, isLoadingPaymentsData } = useGetPaymentsData({ year, month });
    const {rentals } = useRentals()


    const handleSelectChange = (event) => {
        setRental(event.target.value);
    };

    const handleClose = () => {
        setOpen(false);
    };
 

    return (
			<Box m="20px">
				<Grid container spacing={2}>
					<Grid item xs={12}>
						{isLoadingPaymentsData && <ProgressScale />}
						<Typography variant="h2" fontWeight={"bold"}>Tenant Payments</Typography>
						<Grid container spacing={2}>
							<Grid item xs={12} sx={{ marginTop: 3 }}>
								{isLoadingPaymentsData ? <DummyTable /> : <PaymentsTable rows={paymentsData} />}
							</Grid>
						</Grid>
						<FormDialog open={open} handleClose={handleClose} />
					</Grid>
				</Grid>
			</Box>
		);
}